<template>
  <div>
    <v-container>
      <v-row>
        <v-col xs="12" sm="12" md="12">
          <v-radio-group column v-model="group" :class="classPadding">
              <v-radio label="Report of Active and Inactive Employees" value="MANPOWER_ACTIVE"></v-radio>
              <v-radio label="List of Active and Applicant Group by Department" value="MANPOWER_APPLICANTS"></v-radio>
              <v-radio label="List Employees Group by Designation / Craft" value="MANPOWER_CRAFT"></v-radio>
              <v-radio label="List of Inactive / Active Group by Payroll Location" value="MANPOWER_ACTIVE_YARD"></v-radio>
            </v-radio-group>
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12" sm="12" md="12">
          <v-btn
            outlined
            @click.stop="exportReport"
            :loading="loading"
            :class="classPadding"
            >Export</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import moment from "moment";

const API_ENDPOINT = "/api/reports";
export default {
  data: () => ({
    title: "Purge Employee Masterfile",
    classPadding: "my-0 py-0",
    dateFrom: null,
    dateTo: null,
    payLocHeaders: [
      {
        text: "Loc Id",
        align: "left",
        //sortable: false,
        value: "locId",
      },
      {
        text: "Location Name",
        align: "left",
        //sortable: false,
        value: "locName",
      },
    ],
    payLoc: [],
    department: [],
    division: [],
    branch: [],
    section: [],
    isSearching: false,
    employees: [],
    jobLevel: [],
    headers: [
      {
        text: "Code",
        value: "empCode",
        sortable: false,
      },
      {
        text: "Last Name",
        value: "lName",
        sortable: false,
      },
      {
        text: "First Name",
        value: "fName",
        sortable: false,
      },
      {
        text: "Middle Name",
        value: "mName",
        sortable: false,
      },
    ],
    loading: false,
    group: "MANPOWER_ACTIVE",
    group2: "emp",
    panel: [6],
    selectedEmployees: []
  }),
  components: {
  },
  computed: {
  },
  methods: {
    reset() {
      this.dateFrom = null;
      this.dateTo = null;
      this.payLoc = [];
      this.department = [];
      this.division = [];
      this.branch = [];
      this.section = [];
    },
    exportReport() {
      this.loading = true;
      var data = {
          ReportType: this.group
      };
      var url = `${API_ENDPOINT}/manpower-pooling`;
      this.$axios
        .post(url, data)
        .then(({ data }) => {
          var subPath = process.env.VUE_APP_PATH;
          window.open(
            `${subPath.slice(0, -1)}/report-viewer?reportCode=${
              data.reportCode
            }&dbName=${data.dbName}&key=${data.key}&companyKey=${
              data.companyKey
            }&reportUrl=${data.url}&client=${data.client}&logoAlign=${
              data.logoAlign
            }&logoWidth=${data.logoWidth}&rpt=${data.rpt}`
          );
          
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  }
};
</script>
